import { ofType } from 'redux-observable';
import { EMPTY, from, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { Action } from '../actions';
import {
    UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE,
    UpdateCampaignDayBudgetInfoRemoteAction
} from '../actions/campaigns-grid';
import { dailyBudgetOperationsMetrika } from '../actions/campaignsEdit';
import { deleteEditCellData, requestGridItemsBySelection, updateEditCellData } from '../actions/grid-screen';
import { mapDailyBudgetParamsForMetrika } from '../mappers/campaignsEdit/strategy';
import { selectGridSourceParams } from '../selectors/gridSourceParams/gridSourceParams';
import { isDayBudget } from '../typings/budget';
import { Campaign } from '../typings/domain';
import { DnaEpic, DnaEpicAction } from '../typings/epic';

export const updateCampaignDayBudgetEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE),
        mergeMap(
            (action: UpdateCampaignDayBudgetInfoRemoteAction): DnaEpicAction => {
                const state = store$.value;
                const sourceParams = selectGridSourceParams(state);
                const { value, campaignId } = action.params;
                if (!sourceParams || !value) {
                    return EMPTY;
                }

                const targetCampaign = state.grid.gridData.data.find(
                    (campaign: Campaign) => campaign.id === campaignId
                ) as Campaign | undefined;
                const budgetValue = targetCampaign && targetCampaign.budget.value;
                const prevDailyBudget = isDayBudget(budgetValue) && budgetValue.isActive ? budgetValue.sum : undefined;

                const { login, view } = sourceParams;
                const cellKey = {
                    ...action.cellKeyPartial,
                    view: view
                };

                const metrikaActionPaylod = mapDailyBudgetParamsForMetrika(prevDailyBudget, value.sum);
                const metrikaAction = metrikaActionPaylod && dailyBudgetOperationsMetrika(metrikaActionPaylod);

                return from(deps.restApiManager.saveCampaignDayBudget(value, campaignId, login)).pipe(
                    mergeMap(
                        (): DnaEpicAction =>
                            [
                                deleteEditCellData(cellKey),
                                requestGridItemsBySelection(view, { campaigns: [campaignId] }),
                                metrikaAction
                            ].filter(Boolean) as Action[]
                    ),
                    catchError(error =>
                        of(
                            updateEditCellData(cellKey, {
                                isSaving: false,
                                error: error.getMessage()
                            })
                        )
                    )
                );
            }
        )
    );
};
